import axios from "axios";
import { format } from "date-fns";

export const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const api = axios.create({ baseURL: `${BACKEND}/api` });

api.interceptors.request.use((c) => {
  const t = localStorage.getItem("owner_token");
  if (t) c.headers.Authorization = `Bearer ${t}`;
  return c;
});

export const photoSrc = (url) => (url?.startsWith("/api") ? `${BACKEND}${url}` : url);

export const money = (n) =>
  `$${Number(n || 0).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export const errMsg = (e) => {
  const d = e?.response?.data?.detail;
  if (!d) return "Something went wrong. Please try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || "").join(" ");
  return String(d);
};

export const toISO = (d) => format(d, "yyyy-MM-dd");
export const fromISO = (s) => {
  if (!s) return undefined;
  const [y, m, d] = s.split("-").map(Number);
  return new Date(y, m - 1, d);
};
export const prettyDate = (s) => (s ? format(fromISO(s), "EEE, MMM d, yyyy") : "");
